import { Navigate, useLocation } from 'react-router-dom';
import { PROPERTY_SEARCH_ASSISTANT_PATH } from '@/lib/assistantRoutes';

/** Preserves query string when redirecting legacy property-search URLs to the assistant. */
export function SearchAssistantRedirect() {
    const { search } = useLocation();
    return <Navigate to={`${PROPERTY_SEARCH_ASSISTANT_PATH}${search}`} replace />;
}
